import { render, staticRenderFns } from "./RetailerProducts.vue?vue&type=template&id=f9635a42"
import script from "./RetailerProducts.vue?vue&type=script&lang=js"
export * from "./RetailerProducts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports